export const isValidBase64 = (str: string): boolean => {
	if (typeof str !== "string") return false;

	const dataUriPattern =
		/^data:image\/(png|jpeg|jpg|gif|webp|bmp);base64,([A-Za-z0-9+/]+={0,2})$/;

	const match = str.match(dataUriPattern);
	if (!match) return false;

	const base64Data = match[2];

	try {
		atob(base64Data);
		return true;
	} catch {
		return false;
	}
};
